





















import Vue from 'vue'
import firebase from 'firebase'
import * as firebaseui from 'firebaseui'
import 'firebaseui/dist/firebaseui.css'

export default Vue.extend({
  name: 'Home',

  data: () => ({
  }),
  methods: {
    initFirebaseUi () {
      let ui = firebaseui.auth.AuthUI.getInstance()
      if (!ui) {
        ui = new firebaseui.auth.AuthUI(firebase.auth())
      }
      const uiConfig = {
        signInSuccessUrl: this.$store.getters.redirectAfterLoginUrl || '/',
        signInOptions: [firebase.auth.EmailAuthProvider.PROVIDER_ID, firebase.auth.GoogleAuthProvider.PROVIDER_ID],
        credentialHelper: firebaseui.auth.CredentialHelper.NONE
      }
      ui.start('#firebaseui-auth-container', uiConfig)
    }
  },
  async mounted () {
    this.$emit('sub-title-change', 'Log In')
    this.initFirebaseUi()
  }
})
